export default __webpack_public_path__ + "static/media/8468f0e280d7f86ddaf16b4807a89c871581619688941.3c8ff8fd.webp";